module.exports = __webpack_public_path__ + "img/icon_footer_setting_disabled.992edac5.png";